// tslint:disable
export var CaseExternalIdType;
(function (CaseExternalIdType) {
    // ARXCID
    CaseExternalIdType[CaseExternalIdType["ARXCID"] = 1] = "ARXCID";
    // NPID
    CaseExternalIdType[CaseExternalIdType["NPID"] = 2] = "NPID";
    // TRANID
    CaseExternalIdType[CaseExternalIdType["TRANID"] = 3] = "TRANID";
    // MemberNumber
    CaseExternalIdType[CaseExternalIdType["MemberNumber"] = 4] = "MemberNumber";
    // Mig
    CaseExternalIdType[CaseExternalIdType["Mig"] = 5] = "Mig";
    // MedMemberID
    CaseExternalIdType[CaseExternalIdType["MedMemberID"] = 6] = "MedMemberID";
    // PharMemberID
    CaseExternalIdType[CaseExternalIdType["PharMemberID"] = 7] = "PharMemberID";
    // CaseMaskID
    CaseExternalIdType[CaseExternalIdType["CaseMaskID"] = 8] = "CaseMaskID";
    // TCClaimID
    CaseExternalIdType[CaseExternalIdType["TCClaimID"] = 9] = "TCClaimID";
    // DispositionCode
    CaseExternalIdType[CaseExternalIdType["DispositionCode"] = 10] = "DispositionCode";
    // ARXRxId
    CaseExternalIdType[CaseExternalIdType["ARXRxId"] = 11] = "ARXRxId";
    // StgVirmedicaDFID
    CaseExternalIdType[CaseExternalIdType["StgVirmedicaDFID"] = 12] = "StgVirmedicaDFID";
    // TCEobID
    CaseExternalIdType[CaseExternalIdType["TCEobID"] = 13] = "TCEobID";
    // ThirdPartyId
    CaseExternalIdType[CaseExternalIdType["ThirdPartyId"] = 14] = "ThirdPartyId";
    // CarePathId
    CaseExternalIdType[CaseExternalIdType["CarePathId"] = 15] = "CarePathId";
    // VRMResponseId
    CaseExternalIdType[CaseExternalIdType["VRMResponseId"] = 16] = "VRMResponseId";
    // VRMTransactionId
    CaseExternalIdType[CaseExternalIdType["VRMTransactionId"] = 17] = "VRMTransactionId";
    // VRMBVId
    CaseExternalIdType[CaseExternalIdType["VRMBVId"] = 18] = "VRMBVId";
    // VRMPatientId
    CaseExternalIdType[CaseExternalIdType["VRMPatientId"] = 19] = "VRMPatientId";
    // SiteAccountId
    CaseExternalIdType[CaseExternalIdType["SiteAccountId"] = 20] = "SiteAccountId";
    // OtbnStgVirmedicaDFID
    CaseExternalIdType[CaseExternalIdType["OtbnStgVirmedicaDFID"] = 21] = "OtbnStgVirmedicaDFID";
    // ThirdPartyCaseId
    CaseExternalIdType[CaseExternalIdType["ThirdPartyCaseId"] = 22] = "ThirdPartyCaseId";
    // caseMckId
    CaseExternalIdType[CaseExternalIdType["CaseMckId"] = 23] = "CaseMckId";
    // eRx_ID
    CaseExternalIdType[CaseExternalIdType["ERxID"] = 24] = "ERxID";
    // RemsId
    CaseExternalIdType[CaseExternalIdType["RemsId"] = 25] = "RemsId";
    // MangoActivationId
    CaseExternalIdType[CaseExternalIdType["MangoActivationId"] = 26] = "MangoActivationId";
    // EnrollFeedId
    CaseExternalIdType[CaseExternalIdType["EnrollFeedId"] = 27] = "EnrollFeedId";
})(CaseExternalIdType || (CaseExternalIdType = {}));
CaseExternalIdType['MEMBERNUMBER'] = 4;
CaseExternalIdType['MIG'] = 5;
CaseExternalIdType['MEDMEMBERID'] = 6;
CaseExternalIdType['PHARMEMBERID'] = 7;
CaseExternalIdType['CASEMASKID'] = 8;
CaseExternalIdType['TCCLAIMID'] = 9;
CaseExternalIdType['DISPOSITIONCODE'] = 10;
CaseExternalIdType['ARXRXID'] = 11;
CaseExternalIdType['STGVIRMEDICADFID'] = 12;
CaseExternalIdType['TCEOBID'] = 13;
CaseExternalIdType['THIRDPARTYID'] = 14;
CaseExternalIdType['CAREPATHID'] = 15;
CaseExternalIdType['VRMRESPONSEID'] = 16;
CaseExternalIdType['VRMTRANSACTIONID'] = 17;
CaseExternalIdType['VRMBVID'] = 18;
CaseExternalIdType['VRMPATIENTID'] = 19;
CaseExternalIdType['SITEACCOUNTID'] = 20;
CaseExternalIdType['OTBNSTGVIRMEDICADFID'] = 21;
CaseExternalIdType['THIRDPARTYCASEID'] = 22;
CaseExternalIdType['CASEMCKID'] = 23;
CaseExternalIdType['ERXID'] = 24;
CaseExternalIdType['REMSID'] = 25;
CaseExternalIdType['MANGOACTIVATIONID'] = 26;
CaseExternalIdType['ENROLLFEEDID'] = 27;
//# sourceMappingURL=CaseExternalIdType.js.map